function AlertBar() {
	const alertContainer = document.getElementById('e29-alert-bar');
	const alertCookie = getCookie('alert') ? true : false;
	let alertClose = null;
	let alertBarExist = false;

	if (alertContainer) {
		alertClose = alertContainer.querySelector('.alert-bar__close');
	}

	function getCookie(cName) {
		const name = cName + '=';
		const cDecoded = decodeURIComponent(document.cookie);
		const cArr = cDecoded.split('; ');
		let res;
		cArr.forEach((val) => {
			if (val.indexOf(name) === 0) res = val.substring(name.length);
		});
		return res;
	}

	function checkHero(alertTest) {
		const mainPage = document.getElementById('page');
		const alertContainerHeight = alertContainer.getBoundingClientRect().height;

		const header = document.querySelector('.main-header');
		let headerSpacer = header.getBoundingClientRect().height;
		
		headerSpacer = alertTest ? 0 : headerSpacer - alertContainerHeight;
		mainPage.style.setProperty('--current-header-height', headerSpacer + 'px');
	}

	function fade(element) {
		let op = 1;
		const timer = setInterval(function () {
			if (op <= 0.1) {
				clearInterval(timer);
				element.style.display = 'none';
			}
			element.style.opacity = op;
			element.style.filter = 'alpha(opacity=' + op * 100 + ')';
			op -= op * 0.1;
		}, 10);
	}

	if (alertContainer) {
		if (alertCookie) {
			alertContainer.style.display = 'none';
			alertBarExist = false;
		} else {
			alertContainer.style.display = 'block';
			alertBarExist = true;
		}
		document.addEventListener('DOMContentLoaded', () => {
			checkHero(alertBarExist)
		});
	}

	//Close alert item and set local storage
	if (alertClose) {
		alertClose.addEventListener('click', function (e) {
			e.preventDefault();
			document.cookie = 'alert=true; path=/';
			fade(alertContainer);
			checkHero(false);
		});
	}
}

export default AlertBar;
